export function templatedEvents() {
  return ["EMAIL", "TEXT"];
}

export function toggleCall(callCanvasContainer, callFormContainer, contactMethodDropdown) {
  if (!callCanvasContainer || !callFormContainer) return;

  const toggleVisibility = () => {
    callFormContainer.hidden = contactMethodDropdown.value !== "CALL";
    callCanvasContainer.hidden = contactMethodDropdown.value !== "CALL";
  };
  contactMethodDropdown.addEventListener("change", toggleVisibility);
  toggleVisibility();
}

export function setupOutcomeDropdownChoiceManagement(
  outcomeOptionsDropdown,
  contactMethodDropdown,
  directionDropdown,
  contactResultDropdown,
) {
  const outcomesOptions = JSON.parse(outcomeOptionsDropdown.getAttribute("data-outcomes"));

  const updateOutcomeDropdown = () => {
    const optionValues = determineOutcomeOptions(
      outcomesOptions,
      contactMethodDropdown,
      directionDropdown,
      contactResultDropdown,
    );
    reorderDropdownOptions(optionValues, outcomeOptionsDropdown);
  };

  contactResultDropdown.addEventListener("change", updateOutcomeDropdown);
  contactMethodDropdown.addEventListener("change", updateOutcomeDropdown);
  directionDropdown.addEventListener("change", updateOutcomeDropdown);

  // Initialize the dropdown options
  updateOutcomeDropdown();
}

export function toggleOutreachEventMessageBodyInput(
  messageBodyInputDiv,
  messageBodyInput,
  templateMetadata,
  templateDropdown,
) {
  if (templateMetadata[templateDropdown.value] && templateMetadata[templateDropdown.value].allows_message_body_input) {
    messageBodyInputDiv.hidden = false;
    messageBodyInput.hidden = false;
    messageBodyInput.required = true;
  } else {
    messageBodyInputDiv.hidden = true;
    messageBodyInput.hidden = true;
    messageBodyInput.required = false;
  }
}

export function filterTemplateDropdownList(templateMetadata, contactMethodDropdown, templateDropdown) {
  Array.from(templateDropdown.options).forEach((option) => {
    if (
      templateMetadata[option.value] &&
      templateMetadata[option.value].contact_methods &&
      templateMetadata[option.value].contact_methods.includes(contactMethodDropdown.value)
    ) {
      option.hidden = false;
    } else {
      if (option.value !== '') {
        option.hidden = true;
      }
    }
  });
}

export function toggleCallResultSelectVisibility(
  contactResultDropdown,
  contactResultDropdownWrapper,
  contactMethodDropdown,
) {
  if (!contactResultDropdown || !contactResultDropdownWrapper) return;

  const toggleVisibility = (value) => {
    if (value == "CALL") {
      contactResultDropdownWrapper.hidden = false;
      contactResultDropdown.hidden = false;
      contactResultDropdown.required = true;
    } else {
      contactResultDropdownWrapper.hidden = true;
      contactResultDropdown.hidden = true;
      contactResultDropdown.selectedIndex = 0;
      contactResultDropdown.required = false;
    }
  };

  toggleVisibility(contactMethodDropdown.value);
  contactMethodDropdown.addEventListener("change", (e) => {
    toggleVisibility(e.target.value);
  });
}

function determineOutcomeOptions(outcomes, contactMethodDropdown, directionDropdown, contactResultDropdown) {
  // Return empty array unless contact method and direction value are in outcome options
  if (!(contactMethodDropdown.value in outcomes && directionDropdown.value in outcomes[contactMethodDropdown.value])) {
    return [];
  }

  let optionsObj = {};

  if (contactResultDropdown.value in outcomes[contactMethodDropdown.value][directionDropdown.value]) {
    optionsObj = outcomes[contactMethodDropdown.value][directionDropdown.value][contactResultDropdown.value];
  } else {
    optionsObj = outcomes[contactMethodDropdown.value][directionDropdown.value]["DEFAULT"];
  }

  return Object.keys(optionsObj);
}

function reorderDropdownOptions(optionValues, dropdown) {
  // Create an order map from the array
  const orderMap = {};
  optionValues.forEach((value, index) => {
    orderMap[value] = index;
  });

  // Handle grouped select (with optgroups) vs regular select
  const optgroups = dropdown.querySelectorAll('optgroup');

  if (optgroups.length > 0) {
    // Handle grouped select
    optgroups.forEach((optgroup) => {
      const optionsInGroup = Array.from(optgroup.querySelectorAll('option'));

      // Filter and sort options within this group
      const validOptionsInGroup = optionsInGroup.filter(option =>
        orderMap.hasOwnProperty(option.value)
      );

      validOptionsInGroup.sort((a, b) => {
        const orderA = orderMap[a.value];
        const orderB = orderMap[b.value];
        return orderA - orderB;
      });

      // Show/hide options and reorder within the optgroup
      optionsInGroup.forEach((option) => {
        option.hidden = !orderMap.hasOwnProperty(option.value);
      });

      // Reorder the valid options within their optgroup
      validOptionsInGroup.forEach((option) => {
        optgroup.appendChild(option);
      });

      // Hide the optgroup if it has no visible options
      const hasVisibleOptions = optionsInGroup.some(option => !option.hidden);
      optgroup.hidden = !hasVisibleOptions;
    });
  } else {
    // Handle regular select (original logic)
    const optionsArray = Array.from(dropdown.options);

    // Sort the options based on desired order
    optionsArray.sort((a, b) => {
      const orderA = orderMap.hasOwnProperty(a.value) ? orderMap[a.value] : Infinity;
      const orderB = orderMap.hasOwnProperty(b.value) ? orderMap[b.value] : Infinity;
      return orderA - orderB;
    });

    // Update the select element with sorted options
    optionsArray.forEach((option) => {
      // Show or hide the option
      option.hidden = !orderMap.hasOwnProperty(option.value);
      // Append option back to the select element to reorder
      dropdown.appendChild(option);
    });
  }

  // Only reset the selected value if the current value is not in the available options
  const currentValue = dropdown.value;
  if (currentValue && !optionValues.includes(currentValue)) {
    dropdown.value = null;
  }
}
